import { defineMessages } from 'react-intl';

import { LESSON_SEQUENCE_TYPES } from '@didaskill/domain/lessons/constants';

export const sequencesMessages = defineMessages({
  SEQUENCE_NUMBER: {
    defaultMessage: 'Séquence {sequenceNumber, number}',
  },

  EXERCISE_NUMBER: {
    defaultMessage:
      '{sequenceNumber, select, undefined {Entraînement} null {Entraînement} other {Entraînement {sequenceNumber, number}}}',
  },

  ACTIVITY_NUMBER: {
    defaultMessage:
      '{sequenceNumber, select, undefined {Activité} null {Activité} other {Activité {sequenceNumber, number}}}',
  },

  SEQUENCES_COUNT: {
    defaultMessage: '{count, plural, one {# séquence} other {# séquences}}',
  },

  MODULES_COUNT: {
    defaultMessage: '{count, plural, one {# module} other {# modules}}',
  },
});

export const sequenceTypeMessages = defineMessages<LESSON_SEQUENCE_TYPES>({
  [LESSON_SEQUENCE_TYPES.TEXT]: {
    defaultMessage: 'Texte',
  },

  [LESSON_SEQUENCE_TYPES.TRAINING]: {
    defaultMessage: 'Entraînement',
  },

  [LESSON_SEQUENCE_TYPES.ACTIVITY]: {
    defaultMessage: 'Activité',
  },
});

export const lessonsMessages = defineMessages({
  LESSON: {
    defaultMessage: 'Cours',
  },

  RESUME_LESSON: {
    defaultMessage: 'Reprendre le cours',
  },

  AVAILABLE_IN: {
    defaultMessage: 'Disponible dans {count} {count, plural, one {jour} other {jours}}',
  },
});
